// Signup.jsx — zenithpost.ai
// Redesigned: dark editorial theme, larger card, zenithpost.ai branding
// Password stored server-side only via /check-email → pending_users_collection

import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const D = {
  bg:"#0B0C10", surface:"#0F1117", card:"#13151E",
  border:"rgba(255,255,255,0.07)", accent:"#6C7EF8",
  accentDim:"rgba(108,126,248,0.10)", accentBorder:"rgba(108,126,248,0.22)",
  accentGlow:"rgba(108,126,248,0.28)", success:"#34D399",
  danger:"#F87171", dangerDim:"rgba(248,113,113,0.09)", purple:"#A378F8",
  textPrimary:"#EDEEF5", textSec: "#C4C9DC", textMuted: "#7A82A0",
  fontDisplay:"'Bricolage Grotesque','Plus Jakarta Sans',sans-serif",
  fontBody:"'DM Sans',sans-serif", fontMono:"'JetBrains Mono',monospace",
};

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,700;12..96,800&family=DM+Sans:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');
  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  body { background:${D.bg}; color:${D.textPrimary}; font-family:${D.fontBody}; -webkit-font-smoothing:antialiased; }
  ::-webkit-scrollbar { width:4px; }
  ::-webkit-scrollbar-thumb { background:rgba(255,255,255,0.07); border-radius:99px; }
  @keyframes fadeUp   { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
  @keyframes spin     { to{transform:rotate(360deg)} }
  .fu  { animation:fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) both; }
  .d1  { animation-delay:0.07s; }
  .d2  { animation-delay:0.14s; }
  .d3  { animation-delay:0.21s; }
  .pg { position:fixed; inset:0; z-index:0; pointer-events:none;
    background: radial-gradient(ellipse 55% 45% at 20% 10%,rgba(108,126,248,0.07) 0%,transparent 60%),
                radial-gradient(ellipse 40% 35% at 80% 90%,rgba(163,120,248,0.05) 0%,transparent 55%); }
  .f-group { margin-bottom:20px; }
  .f-label { display:block; font-family:${D.fontBody}; font-weight:600; font-size:14px; color:${D.textSec}; margin-bottom:7px; }
  .f-input { width:100%; padding:13px 16px; border-radius:10px; background:rgba(255,255,255,0.04); border:1px solid ${D.border}; color:${D.textPrimary}; font-family:${D.fontBody}; font-size:15px; outline:none; transition:border-color 0.18s,box-shadow 0.18s; }
  .f-input::placeholder { color:${D.textMuted}; }
  .f-input:focus { border-color:${D.accent}; box-shadow:0 0 0 3px ${D.accentDim}; }
  .f-input.err { border-color:${D.danger}; }
  .f-input.err:focus { box-shadow:0 0 0 3px ${D.dangerDim}; }
  .f-wrap { position:relative; }
  .f-eye { position:absolute; right:13px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:${D.textMuted}; font-size:16px; padding:3px; display:flex; align-items:center; transition:color 0.15s; }
  .f-eye:hover { color:${D.textSec}; }
  .f-err { margin-top:5px; font-size:12px; color:${D.danger}; font-family:${D.fontBody}; display:flex; align-items:center; gap:4px; }
  .f-ok  { margin-top:5px; font-size:12px; color:${D.success}; font-family:${D.fontBody}; display:flex; align-items:center; gap:4px; }
  .str-bg { height:3px; border-radius:99px; background:rgba(255,255,255,0.07); overflow:hidden; margin-top:8px; }
  .str-fill { height:100%; border-radius:99px; transition:width 0.35s,background 0.35s; }
  .rules { margin-top:10px; padding:12px 14px; border-radius:10px; background:rgba(255,255,255,0.025); border:1px solid ${D.border}; display:flex; flex-direction:column; gap:5px; }
  .rule { display:flex; align-items:center; gap:7px; font-family:${D.fontMono}; font-size:12px; }
  .r-ok { color:${D.success}; }
  .r-no { color:${D.textMuted}; }
  .btn-p { width:100%; padding:14px; border-radius:11px; border:none; background:linear-gradient(135deg,${D.accent} 0%,#8B72F8 100%); color:white; font-family:${D.fontBody}; font-size:15px; font-weight:700; cursor:pointer; box-shadow:0 6px 24px ${D.accentGlow}; transition:transform 0.15s,box-shadow 0.15s,opacity 0.15s; display:flex; align-items:center; justify-content:center; gap:8px; }
  .btn-p:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 10px 32px rgba(108,126,248,0.42); }
  .btn-p:disabled { opacity:0.55; cursor:not-allowed; }
  .spinner { width:15px; height:15px; border-radius:50%; border:2px solid rgba(255,255,255,0.25); border-top-color:white; animation:spin 0.7s linear infinite; flex-shrink:0; }
  .divider { display:flex; align-items:center; gap:12px; margin:20px 0; }
  .div-line { flex:1; height:1px; background:${D.border}; }
  .div-txt { font-family:${D.fontMono}; font-size:10px; color:${D.textMuted}; }
  .steps { display:flex; align-items:center; gap:5px; margin-bottom:24px; }
  .step-dot { height:3px; border-radius:99px; }
  @media (max-width: 480px) {
    .card-header { padding: 24px 22px 22px !important; }
    .card-body   { padding: 24px 22px 26px !important; }
  }
`;

const RULES_DEF = [
  { id:"len",     label:"At least 8 characters",  test: p => p.length >= 8 },
  { id:"upper",   label:"One uppercase letter",    test: p => /[A-Z]/.test(p) },
  { id:"lower",   label:"One lowercase letter",    test: p => /[a-z]/.test(p) },
  { id:"number",  label:"One number",              test: p => /\d/.test(p) },
  { id:"special", label:"One special character",   test: p => /[!@#$%^&*(),.?":{}|<>]/.test(p) },
];
const strengthOf = pw => {
  if (!pw) return { score:0, label:"", color:D.border };
  const n = RULES_DEF.filter(r => r.test(pw)).length;
  if (n<=1) return { score:20,  label:"Very weak",   color:"#F87171" };
  if (n===2) return { score:40,  label:"Weak",        color:"#FB923C" };
  if (n===3) return { score:60,  label:"Fair",        color:"#F59E0B" };
  if (n===4) return { score:80,  label:"Strong",      color:"#84CC16" };
  return           { score:100, label:"Very strong", color:D.success };
};

export default function Signup() {
  const navigate = useNavigate();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [showPw, setShowPw]     = useState(false);
  const [showCp, setShowCp]     = useState(false);
  const [pwFocus, setPwFocus]   = useState(false);
  const [errors, setErrors]     = useState({});
  const [loading, setLoading]   = useState(false);
  const strength = strengthOf(password);

  const validate = () => {
    const e = {};
    if (!email.trim())    e.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = "Enter a valid email address";
    if (!password)        e.password = "Password is required";
    else { const fail = RULES_DEF.find(r => !r.test(password)); if (fail) e.password = fail.label + " required"; }
    if (!confirm)         e.confirm = "Please confirm your password";
    else if (password !== confirm) e.confirm = "Passwords do not match";
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleNext = async () => {
    setErrors({});
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL || "http://localhost:8000"}/api/auth/check-email`, { email, password });
      const s = res.data.status;
      if (s === "invalid_email")      { setErrors({ email:"Email is not valid" }); return; }
      if (s === "already_registered") { setErrors({ email:"Account already exists. Try logging in." }); return; }
      localStorage.setItem("email", email.trim().toLowerCase());
      navigate("/brand-profile");
    } catch (err) {
      setErrors({ general: err.response?.data?.detail || "Something went wrong. Please try again." });
    } finally { setLoading(false); }
  };

  const onKey = e => { if (e.key === "Enter") handleNext(); };
  const clr   = f => setErrors(v => ({ ...v, [f]: undefined }));

  return (
    <>
      <style>{CSS}</style>
      <div className="pg" />
      <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 20px", position:"relative", zIndex:1 }}>

        {/* Logo */}
      <div 
  onClick={() => navigate("/")} 
  style={{ cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:12 }}
>
  <div style={{ width:54, height:54, borderRadius:15, background:`linear-gradient(135deg,${D.accent} 0%,${D.purple} 100%)`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:D.fontDisplay, fontWeight:800, fontSize:26, color:"white", boxShadow:`0 8px 28px ${D.accentGlow}` }}>Z</div>
  <div style={{ fontFamily:D.fontDisplay, fontWeight:700, fontSize:16, color:D.textPrimary }}>zenithpost<span style={{ color:D.accent }}>.ai</span></div>
</div>

        {/* Card */}
        <div className="fu d1" style={{ width:"100%", maxWidth:500, background:D.card, borderRadius:22, border:`1px solid ${D.border}`, boxShadow:"0 32px 80px rgba(0,0,0,0.45)", overflow:"hidden" }}>

          {/* Header */}
          <div className="card-header" style={{ background:"linear-gradient(135deg,#0D0D12 0%,#1A1A2E 100%)", padding:"32px 36px 28px", position:"relative", overflow:"hidden" }}>
            <div style={{ position:"absolute", inset:0, background:"radial-gradient(ellipse at 80% 50%,rgba(108,126,248,0.28) 0%,transparent 60%)", pointerEvents:"none" }} />
            <div className="steps">
              <div className="step-dot" style={{ width:32, background:D.accent }} />
              <div className="step-dot" style={{ width:16, background:"rgba(255,255,255,0.15)" }} />
              <span style={{ fontFamily:D.fontMono, fontSize:10, color:"rgba(255,255,255,0.35)", letterSpacing:"0.08em", marginLeft:4 }}>STEP 1 OF 2</span>
            </div>
            <div style={{ fontFamily:D.fontDisplay, fontWeight:800, fontSize:28, color:"white", lineHeight:1.15, marginBottom:8 }}>Create your account</div>
            <div style={{ fontSize:14.5, color:"rgba(255,255,255,0.50)", lineHeight:1.65 }}>Then we'll build your AI brand intelligence together.</div>
          </div>

          {/* Form */}
          <div className="card-body" style={{ padding:"32px 36px 36px" }}>
            {errors.general && (
              <div style={{ display:"flex", gap:10, padding:"12px 16px", marginBottom:20, borderRadius:10, background:"rgba(248,113,113,0.09)", border:"1px solid rgba(248,113,113,0.22)" }}>
                <span style={{ fontSize:15, flexShrink:0 }}>⚠</span>
                <span style={{ fontSize:13, color:D.danger, lineHeight:1.55 }}>{errors.general}</span>
              </div>
            )}

            {/* Email */}
            <div className="f-group">
              <label className="f-label">Email address</label>
              <input className={`f-input${errors.email?" err":""}`} type="email" placeholder="you@company.com"
                value={email} onChange={e=>{setEmail(e.target.value);clr("email");}} onKeyDown={onKey} />
              {errors.email && <div className="f-err">⚠ {errors.email}</div>}
            </div>

            {/* Password */}
            <div className="f-group">
              <label className="f-label">Password</label>
              <div className="f-wrap">
                <input className={`f-input${errors.password?" err":""}`} type={showPw?"text":"password"} placeholder="Min. 8 characters"
                  value={password} onChange={e=>{setPassword(e.target.value);clr("password");}}
                  onFocus={()=>setPwFocus(true)} onBlur={()=>setPwFocus(false)} onKeyDown={onKey}
                  style={{ paddingRight:44 }} />
                <button className="f-eye" type="button" onClick={()=>setShowPw(s=>!s)} tabIndex={-1}>{showPw?"🙈":"👁"}</button>
              </div>
              {errors.password && <div className="f-err">⚠ {errors.password}</div>}
              {password && (
                <div>
                  <div style={{ display:"flex", justifyContent:"space-between", marginTop:7, marginBottom:4 }}>
                    <span style={{ fontFamily:D.fontMono, fontSize:10, color:D.textMuted }}>Strength</span>
                    <span style={{ fontFamily:D.fontMono, fontSize:10, fontWeight:700, color:strength.color }}>{strength.label}</span>
                  </div>
                  <div className="str-bg"><div className="str-fill" style={{ width:`${strength.score}%`, background:strength.color }} /></div>
                </div>
              )}
              {(pwFocus || password) && (
                <div className="rules">
                  {RULES_DEF.map(r => {
                    const ok = r.test(password);
                    return <div key={r.id} className={`rule ${ok?"r-ok":"r-no"}`}><span>{ok?"✓":"○"}</span><span>{r.label}</span></div>;
                  })}
                </div>
              )}
            </div>

            {/* Confirm */}
            <div className="f-group">
              <label className="f-label">Confirm password</label>
              <div className="f-wrap">
                <input className={`f-input${errors.confirm?" err":""}`} type={showCp?"text":"password"} placeholder="Re-enter your password"
                  value={confirm} onChange={e=>{setConfirm(e.target.value);clr("confirm");}} onKeyDown={onKey}
                  style={{ paddingRight:44 }} />
                <button className="f-eye" type="button" onClick={()=>setShowCp(s=>!s)} tabIndex={-1}>{showCp?"🙈":"👁"}</button>
              </div>
              {errors.confirm && <div className="f-err">⚠ {errors.confirm}</div>}
              {confirm && password && (
                <div className={password===confirm?"f-ok":"f-err"} style={{ color: password===confirm ? D.success : D.textMuted }}>
                  {password===confirm ? "✓ Passwords match" : "○ Passwords don't match yet"}
                </div>
              )}
            </div>

            {/* Submit */}
            <div style={{ marginTop:28 }}>
              <button className="btn-p" onClick={handleNext} disabled={loading}>
                {loading ? <><div className="spinner" />Checking…</> : "Continue to Brand Profile →"}
              </button>
            </div>

            <div className="divider"><div className="div-line" /><span className="div-txt">OR</span><div className="div-line" /></div>

            <div style={{ textAlign:"center", fontSize:13.5, color:D.textSec }}>
              Already have an account?{" "}
              <Link to="/login" style={{ color:D.accent, fontWeight:700, textDecoration:"none" }}>Log in</Link>
            </div>
          </div>
        </div>

        <div className="fu d2" style={{ marginTop:24, textAlign:"center" }}>
          <p style={{ fontFamily:D.fontMono, fontSize:10.5, color:D.textMuted }}>
            By signing up you agree to our <a href="/terms" style={{ color:D.textMuted, textDecoration:"underline" }}>Terms</a> &amp; <a href="/privacy" style={{ color:D.textMuted, textDecoration:"underline" }}>Privacy Policy</a>.
          </p>
        </div>
      </div>
    </>
  );
}